"use strict";
const React = require('react');
const models_1 = require('../models');
const Flex_1 = require('./Flex');
const c = require('./theme/colors');
const RepeatSelectItem = (props) => React.createElement("div", {onTouchTap: (e) => { e.preventDefault(); props.onTouchTap(e); }, style: style.repeatSelectItem(props)}, props.text);
const WEEKDAYS = "SMTWTFS".split('');
class RepeatSelect extends React.Component {
    constructor(props) {
        super(props);
        this.buildStateFromProps = (props) => ({
            repeats: props.repeats,
        });
        this.handleItemTouchTap = (index) => {
            if (this.props.disabled) {
                return;
            }
            const repeats = this.state.repeats.slice();
            repeats[index] = !repeats[index];
            this.setState({ repeats });
        };
        this.state = this.buildStateFromProps(props);
    }
    componentWillReceiveProps(nextProps) {
        this.setState(this.buildStateFromProps(nextProps));
    }
    getRepeats() {
        return this.props.disabled ? models_1.GOAL_REPEATS_DEFAULT : this.state.repeats;
    }
    render() {
        return (React.createElement(Flex_1.Row, {style: { justifyContent: 'space-between' }}, this.renderItems()));
    }
    renderItems() {
        return WEEKDAYS.map((day, index) => React.createElement(RepeatSelectItem, {key: index, disabled: this.props.disabled, text: day, isSelected: this.state.repeats[index], onTouchTap: () => this.handleItemTouchTap(index)}));
    }
}
const style = {
    repeatSelectItem: (props) => ({
        alignItems: 'center',
        backgroundColor: !props.disabled && props.isSelected ? c.blue : c.transparent,
        border: `2px solid ${props.disabled ? c.whiteTransparent : c.blue}`,
        borderRadius: '100%',
        color: !props.disabled && props.isSelected ? c.white : c.whiteTransparent,
        cursor: 'pointer',
        display: 'flex',
        height: '36px',
        justifyContent: 'center',
        width: '36px',
    }),
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RepeatSelect;



/** WEBPACK FOOTER **
 ** ./src/components/RepeatSelect.tsx
 **/